export default "__VITE_ASSET__29626518__"